import { render } from "./AsEarned.vue?vue&type=template&id=ae1ead5a"
import script from "./AsEarned.vue?vue&type=script&lang=js"
export * from "./AsEarned.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__